'use strict';

import $ from 'jquery';
import ModalView from '../../js/components/ModalView';
import templateIdleActivityModal from './templates/_IdleActivityModal.hbs';
import cookies from 'js-cookie';
import config from '../../js/config';
import cacheCookieHelper from '../../components/CacheCookieHelper/CacheCookieHelper';

let instance = null;


export default class IdleActivityModal extends ModalView {
  initialize() {
    super.initialize({ template: templateIdleActivityModal, remodal: { closeOnOutsideClick: false } });
  }

  initializeElements() {
    this.$submitButton = this.$el.find('#IdleActivityForm-submit');
    this.$cancelButton = this.$el.find('#IdleActivity-modal-cancel');
    this.$modalContainer = this.$el.find('.Modal-dialog.IdleActivity-modal');
    this.$activeElement = $(document.activeElement);
    cookies.set(config.cookies.sessionExtend, false);
  }

  open() {
    this.renderModal();
    super.open();
  }

  modalClosing() {
    super.modalClosing();
    this.$modalContainer.removeAttr('aria-modal');
    this.$activeElement.focus();
    if (cookies.get(config.cookies.sessionExtend) === 'false' || cookies.get(config.cookies.sessionExtend) === '') {
      let currentURL = new URL(window.location.origin);
      window.location.href = currentURL;
    }
  }

  renderModal() {
    // Render main view
    this.$el.html(this.template());
  }

  onOpen() {
    this.initializeElements();
    this.$modalContainer.attr('aria-modal',true);
    this.$submitButton.focus();
    this.$cancelButton.on('keydown',(e)=>{
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        this.$submitButton.focus();
      }
    });
    this.$submitButton.on('keydown', (e)=>{
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        this.$cancelButton.focus();
      }
    });
  }

  onConfirm() {
    cookies.set(config.cookies.sessionExtend, true);
    super.close();
  }

  onCancel() {
    cookies.set(config.cookies.sessionExtend, false);
    cookies.set(config.cookies.arrowFed, '', '');
    if (cacheCookieHelper) {
      cacheCookieHelper.setCacheCookie();
    }
    super.close();
  }

  static getInstance() {
    if (!instance) {
      instance = new IdleActivityModal();
    }

    return instance;
  }

}



// WEBPACK FOOTER //
// ./assets/components/IdleActivityWatcher/IdleActivityModal.js